<template>
  <div class="hanzo-shop-card">
    <div class='frame skeleton' v-if="skeleton">
      <div class="kenleton-content">
        <div class='avatar item'></div>
        <div>
          <div class='storeTit item'></div>
          <div class='line item'></div>
        </div>
        <div class="col-right">
          <div class='right item'></div>
          <div class='right item'></div>
        </div>
      </div>
    </div>

    <div class="frame global-silk-bg" v-else>
      <div class="card">
        <div class="info">
          <img class='infoimg' :src="head"/>
          <div class="desc">
            <div class="name global-text-line-overflow">{{name}}</div>
            <div class="slogon">{{sLogon}}</div>
          </div>
        </div>
        <div class="split"></div>
        <div class="data">
          <div class="follow">
            <div class="number">{{fans}}</div>
            <div class="desc">粉丝数</div>
          </div>
          <div class="saled">
            <div class="number">{{follows}}</div>
            <div class="desc">购买指数</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: "h-shop-card",
    components: {

    },
    props: {
      // 是否显示骨架
      skeleton:{
        type:Boolean,
        default: false,
      },
      head:{
        type:String,
        default: 'http://xsyx-front-xps.oss-cn-shenzhen.aliyuncs.com/2019/06/26/1076287493.jpg'
      },
      name: String,
      sLogon: {
        type:String,
        default: '兴盛你我他，优选人人夸'
      },
      // 粉丝
      fans: {
        type:String | Number,
        default:0
      },
      // 购买指数
      follows: {
        type:String | Number,
        default:0
      },
    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>
